/**
 * KMS access helpers.
 *
 * When a visitor arrives via /kms or /kms/shop, a `kms_access=1` flag is set
 * in sessionStorage. Any child component (challenge signup buttons, "See all
 * merch" links, etc.) can call `shopHref()` to route them into the hidden
 * KMS variant of the shop instead of the public one — without introducing a
 * separate KMS challenge, cart, checkout, or leaderboard.
 *
 * The flag has NO effect on data flow: signups, wall entries, minutes
 * logging, donations, checkout, and Printful fulfillment all use the same
 * shared endpoints and database as the public site. It is purely a routing
 * hint.
 */
export function isKmsAccess() {
  if (typeof window === "undefined") return false;
  try {
    return window.sessionStorage.getItem("kms_access") === "1";
  } catch { return false; }
}

/** Return `/kms/shop` when the visitor entered through /kms, `/shop` otherwise. */
export function shopHref() {
  return isKmsAccess() ? "/kms/shop" : "/shop";
}
